import { AUTHOR_EVENTS } from '../../../constants/author-profile-events';
import qualityEventsHelpers from '../quality-events.helpers';

export const AUTHOR_QUALITY_EVENTS = {
    userProfileAction(action: AUTHOR_EVENTS | string) {
        qualityEventsHelpers.track({
            type: 'userProfileAction',
            extra: action
        });
    },
    followTheAuthor({ source, authorId }: { source: string; authorId: Author['id'] }) {
        qualityEventsHelpers.track({
            type: 'ap_FollowTheAuthor',
            source,
            extra: JSON.stringify({ author_id: authorId })
        });
    },
    unfollowTheAuthor({ source, authorId }: { source: string; authorId: Author['id'] }) {
        qualityEventsHelpers.track({
            type: 'ap_UnfollowTheAuthor',
            source,
            extra: JSON.stringify({ author_id: authorId })
        });
    }
};
